<template>
  <Modal
    :is-modal-open="isModalOpen"
    :vendor-id="vendorId"
    :vendor-key="vendorKey"
    @close-modal="closeModal"
    @consent-updated="handleConsentUpdated"
  />
</template>

<script setup>
import { onMounted, onUnmounted, ref, shallowRef } from 'vue';
import { getVendorConsent } from '../../globals/consentmanager';
import { getMarketingConsent } from '../../globals/cookiebot';
import Modal from '../../components/Modal/Modal.vue';

const props = defineProps({
  vendorKey: {
    type: String,
    required: true,
  },
  vendorId: {
    type: String,
    required: true,
  },
  triggerSelector: {
    type: String,
    required: true,
  },
});

const isModalOpen = ref(false);
const pendingTarget = shallowRef(null);

const closeModal = () => {
  isModalOpen.value = false;
  pendingTarget.value = null;
};

const handleConsentUpdated = (consentGiven) => {
  if (!consentGiven || !pendingTarget.value) {
    return;
  }

  const target = pendingTarget.value;
  pendingTarget.value = null;
  isModalOpen.value = false;
  setTimeout(() => target.click(), 0);
};

const handleClick = (event) => {
  const target =
    event.target instanceof Element ? event.target.closest(props.triggerSelector) : null;
  const consentGiven = window.Cookiebot
    ? getMarketingConsent()
    : getVendorConsent(props.vendorId);

  if (!target || consentGiven) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  pendingTarget.value = target;
  isModalOpen.value = true;
};

onMounted(() => {
  document.addEventListener('click', handleClick, true);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClick, true);
});
</script>
